<template>
  <div >
    <iframe id="inlineFrameExample"
      title="Inline Frame Example"
      width="500"
      height="500"
      :src="this.urlLogin">
  </iframe>

    <div class="row">
      <template v-if="grams.length > 0">
        <div v-for="(gram, index) in grams" :key="index" class="container-insta">
          <!-- <div class="content-insta">
            <a @click="openModal(gram)">
              <div class="content-insta-overlay"></div>
              <img :src="gram.node.thumbnail_src" :alt="gram.node.accessibility_caption" class="content-insta-image"/>
              <div class="content-insta-details fadeIn-top">
                <h4>{{ fullname }}</h4>
                <p>{{ username }}</p>
              </div>
            </a>
          </div> -->
          <div class="content-insta">
            <a @click="openModal(gram)">
              <div class="content-insta-overlay"></div>
              <img :src="gram.media_url" :alt="gram.text" class="content-insta-image"/>
              <div class="content-insta-details fadeIn-top">
                <h4>{{ fullname }}</h4>
                <p>{{ username }}</p>
              </div>
            </a>
          </div>
        </div>
      </template>
      <div v-else class="loading"></div>
      <div v-if="error" class="error">No hay contenido</div>
      <!-- <button @click="getMoreGrams">Load More</button> -->
    </div>
    <transition name="modal">
      <modal-insta :gram="gramAux" v-if="modal" v-on:cerrar="modal = false"></modal-insta>
    </transition>
  </div>
</template>
<script>

import { InstagramApiService } from '@/api/InstagramApiService'
import ModalInstagram from '@/views/ModalInstagram'
import axios from 'axios';
const instagramApiService = new InstagramApiService()

export default {
  data () {
    return {
      access_token: "",
      urlGraph: "https://graph.instagram.com/",
      urlLogin: "https://api.instagram.com/oauth/authorize?client_id=339763363652257&redirect_uri=https://httpstat.us/200&scope=user_profile,user_media&response_type=code",
      urlToken: "https://api.instagram.com/oauth/access_token",
      instaCode: "",
      username: "",
      fullname: "",
      grams: [],
      next_url: "",
      error: false,
      gramAux: "",
      modal: false,
      
    }
  },
  components :{
    'modal-insta' : ModalInstagram
  },
  computed: {
    instapage() {
      return 'https://www.instagram.com/' + this.username
    }
  },
  created() {
    if (localStorage.getItem("tokenInsta") == null || localStorage.getItem("tokenInsta") =='') {
      //mostramos la modal de logueo
      this.showModalLogin=true
      
    } else {
      this.access_token = localStorage.getItem("tokenInsta")
      this.userIdInsta = localStorage.getItem("userIdInsta")
    }
    this.getAccessToken()
    // this.cambioTitulo()
    // this.getGrams()
    // this.getInstagram()
  },
  methods: {
    cambioTitulo () {
      this.$store.state.tituloIcono = `<i class="icon-instagram"></i>`
      this.$store.state.titulo = "Instagram"
    },
    openModal (gram) {
      this.gramAux = gram
      this.modal = true
    },
    getGrams() {
      axios.get(this.url + this.userIdInsta + "/media?access_token=" + this.access_token + "&fields=caption,children,comments,comments_count,id,ig_id,like_count,media_type,media_url,permalink,thumbnail_url,timestamp,username")
        .then(({data}) => {
          console.log(data)
        })
        .catch(function (error) {
          console.log(error)
        });
    },
    getAccessToken() {
      let formData = {
        client_id : "339763363652257",
        client_secret: "17b3b7e583888aa50abfab3932601a77",
        grant_type: "authorization_code",
        redirect_uri: "https://httpstat.us/200",
        code: "AQCrVuTaYWp7lYKp-pW-of3NTcB_Kf2Td6I5Ln6StzuSuxaRxZDrp7S2fifdCLrOATFxFihQ_ari_513plzfXQ_93pm75T-hHOk99H6T4Wr29_tIr48f5U5brnw_30VgH-MTO0kJSIcM5HW2McPzXZPBmDrtWdsmyOEBQrUKgwokwkgO1z8BQQ76WoDPLYeNYf-BnPrrymlxU5mVnSfAJx83gGPEg8kMvU2JMAa_rJNY-g#/_",

      }
     let config = {
      headers: {'Content-Type': 'multipart/form-data'}
    };
      axios.post(this.urlToken, formData, config)
        .then(({data}) => {
                console.log(data)
              })
              .catch(function (error) {
                console.log(error)
              });
    }
    // getMoreGrams(){
    //   let self = this
    //   axios.get(this.next_url)
    //     .then(({data}) => {
    //       this.grams = this.grams.concat(data.data)
    //       this.next_url = data.pagination.next_url
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //       self.error = true
    //     });         
    // },
    // getInstagram() {
    //  fetch('https://www.instagram.com/texturainteriors',{mode: "no-cors"})
    //     .then(response => response.text())
    //     .then((data) => {
    //       var insta_source = data
    //       var shards = insta_source.split('window._sharedData = ')
    //       var insta_json = shards[1].split(';<\/script>') 
    //       // console.log(insta_json[0])
    //       insta_json = JSON.parse(insta_json[0])
    //       this.fullname = insta_json.entry_data.ProfilePage[0].graphql.user.full_name
    //       this.username = insta_json.entry_data.ProfilePage[0].graphql.user.username
    //       this.grams =  insta_json.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges
    //     })
    // }
    // getInstagram() {
    //  instagramApiService.getInstagram()
    //     .then(data => {
    //       var insta_source = data
    //       var shards = insta_source.split('window._sharedData = ')
    //       var insta_json = shards[1].split(';<\/script>') 
    //       // console.log(insta_json[0])
    //       insta_json = JSON.parse(insta_json[0])
    //       this.fullname = insta_json.entry_data.ProfilePage[0].graphql.user.full_name
    //       this.username = insta_json.entry_data.ProfilePage[0].graphql.user.username
    //       this.grams =  insta_json.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges
    //     })
    // }
  },
 
}
</script>

